<div class="mb-4 flex justify-end">
  <!--  <address-client-form-->
  <!--    (response)="responseForm($event)"-->
  <!--    [editItem]="item"-->
  <!--  ></address-client-form>-->
  <button
    mat-raised-button
    class="btn-add"
    [ngClass]="idClient < 0 || !idClient ? 'disabled' : ''"
    (click)="addItemProposal()"
    [disabled]="idClient < 0 || !idClient"
  >
    Inserir
    <mat-icon>add</mat-icon>
  </button>
</div>
@if (itemsList.length > 0) {
  <div>
    <div class="tab-overflow">
      <table mat-table [dataSource]="tableSource" class="mat-elevation-z8">
        @for (column of columns; track column.keyColumn) {
          <ng-container matColumnDef="{{ column.keyColumn }}">
            <th mat-header-cell *matHeaderCellDef>{{ column.description }}</th>
            <td mat-cell *matCellDef="let element">
              @if (column.keyColumn == 'action') {
                <div class="flex justify-center items-center gap-3">
                  @if (column.key.edit) {
                    <mat-icon
                      class="btn-icon-outline"
                      fontIcon="edit"
                      (click)="selectItemEvent(element)"
                    />
                  }
                  @if (column.key.delete) {
                    <mat-icon
                      class="btn-icon-outline"
                      fontIcon="delete"
                      (click)="deleteItemEvent(element)"
                    />
                  }
                  @if (column.key.duplicate) {
                    <mat-icon
                      class="btn-icon-outline"
                      fontIcon="library_add"
                      (click)="duplicateItemProposal(element)"
                    />
                  }
                </div>
              } @else if (column.keyColumn == 'cost_IP') {
                <b>Valor: </b
                >{{
                  element.vendaSemTaxaFormatado != 'R$ '
                    ? element.vendaSemTaxaFormatado
                    : 'R$ 0,00'
                }}<br />
                <b>C. Taxa: </b
                >{{
                  element.vendaFormatado != 'R$ '
                    ? element.vendaFormatado
                    : 'R$ 0,00'
                }}
              } @else if (column.keyColumn == 'location_OD') {
                <b>Origem</b><br />
                Cidade: {{ element.cidadeOrigem }}<br />
                Estado: {{ element.estadoOrigem }}<br />
                <b>Destino</b><br />
                Cidade: {{ element.cidadeDestino }}<br />
                Estado: {{ element.estadoDestino }}
                <!--                <b>Origem: </b>{{ element.origem }}<br />-->
                <!--                <b>Destino: </b>{{ element.destino }}-->
              } @else if (column.keyColumn == 'servico_TS') {
                <b>Tipo: </b>{{ element.tipoServico }}<br />
                <b>Serviço: </b>{{ element.servico }}
              } @else if (column.keyColumn == 'vehicle_VM') {
                <b>Tipo veículo: </b>{{ element.tipoVeiculo }}<br />
                <b>Tipo motorista: </b>{{ element.tipoMotorista }}
              } @else if (column.keyColumn == 'custoExtra_HK') {
                <b>Hora: </b
                >{{
                  element.saleKmExtraFormatado != 'R$ '
                    ? element.saleKmExtraFormatado
                    : 'R$ 0,00'
                }}<br />
                <b>KM: </b
                >{{
                  element.saleHoraExtraFormatado != 'R$ '
                    ? element.saleHoraExtraFormatado
                    : 'R$ 0,00'
                }}
              } @else if (column.keyColumn == 'valid') {
                @if (element[column.key] == true) {
                  @if (element.tarifario.id && element.tarifario.id != '') {
                    <span class="tag-clone-valid">Regularizado</span>
                  } @else {
                    <span class="tag-clone-build">Compras</span>
                  }
                } @else {
                  <span class="tag-clone-invalid">Aguardando validação</span>
                }
              } @else {
                {{ element[column.key] }}
              }
            </td>
          </ng-container>
        }
        <tr
          mat-header-row
          class="style-header"
          *matHeaderRowDef="displayedColumns"
        ></tr>
        <tr
          mat-row
          class="style-row"
          *matRowDef="let row; columns: displayedColumns"
        ></tr>
      </table>
    </div>
    <mat-paginator #paginator [pageSize]="5"> </mat-paginator>
  </div>
}

<!--<div>-->
<!--  <table-list-form-->
<!--    [dataSource]="itemsList"-->
<!--    [columns]="columns"-->
<!--    (selectItem)="editItem($event)"-->
<!--    (deleteItem)="deleteItem($event)"-->
<!--  />-->
<!--</div>-->
